module.exports = __webpack_public_path__ + "media/images/how_it_works-4b58ee470b2b3980e93792cec4699713.png";